import { createSelector } from 'reselect';
import { getCallMobileState } from './call-mobile-state';
import { selectors as callSelectors } from '../../call';
import { getFirstParam } from '../../core';
export const getParticipantsView = (state) => getCallMobileState(state).participantsView;
export const getGridViewOpenState = (state) => getCallMobileState(state).isGridViewOpen;
export const getCurrentParticipantIdForActions = (state) => getCallMobileState(state).actionsParticipantId;
export const getParticipantForActions = createSelector(getCurrentParticipantIdForActions, getFirstParam, (currentId, state) => {
    return callSelectors.getParticipantById(state, currentId);
});
